import { apiFetch } from "./client";
import { adaptCourse } from "./adapters";

export const listCourses = async () =>
  (await apiFetch("/api/courses")).map(adaptCourse);

export const getCourse = async (id) => adaptCourse(await apiFetch(`/api/courses/${id}`));

export const createCourse = async ({ name, description, status, editorIds = [] }) =>
  adaptCourse(
    await apiFetch("/api/courses", {
      method: "POST",
      body: { name, description, status, editor_ids: editorIds },
    })
  );

export const updateCourse = async (id, { name, description, status, editorIds }) =>
  adaptCourse(
    await apiFetch(`/api/courses/${id}`, {
      method: "PUT",
      body: {
        name,
        description,
        status,
        ...(editorIds !== undefined ? { editor_ids: editorIds } : {}),
      },
    })
  );

export const setCourseStatus = async (id, status) =>
  adaptCourse(
    await apiFetch(`/api/courses/${id}/status`, { method: "PATCH", body: { status } })
  );

export const deleteCourse = (id) => apiFetch(`/api/courses/${id}`, { method: "DELETE" });

export const removeEditor = (id, userId) =>
  apiFetch(`/api/courses/${id}/editors/${userId}`, { method: "DELETE" });
